import React from 'react';
import { Input, Button, PaperClip, Select } from 'components';
import { ServiceService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalView extends React.Component<Props> {
	
	render() {
		return (
			<div id="modal-view-service">
				<div className="container-data">
					<p><strong>Tipo de Servicio:</strong> { this.props.item?.service?.name }</p>
					<p><strong>Descripción:</strong> { this.props.item?.description }</p>
					<p><strong>Precio:</strong> { Globals.formatMiles(this.props.item?.amount) }</p>
				</div>
				<div className="row row-buttons">
					<div className="col-md-12 text-center">
						<Button type="button" onClick={ () => this.props.onClose() }>
							Cerrar
						</Button>
					</div>
				</div>
			</div>
		)
	}
}

export default ModalView;